import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row q-gutter-x-lg form-field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_local_date_picker = _resolveComponent("local-date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_local_date_picker, {
      label: _ctx.t('EFFECTIVE_DATE.LABEL'),
      mandatory: "",
      class: "col",
      "model-value": _ctx.effectiveDate,
      "onUpdate:modelValue": _ctx.updateEffectiveDate
    }, null, 8, ["label", "model-value", "onUpdate:modelValue"])
  ]))
}